module.exports = __webpack_public_path__ + "img/Remaining_Money.db3fb40b.jpg";